/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../../history';
import actions from '../../../actions';
import ClientsTable from './table';
import { withRefreshTableOnFilterChange } from '../common/decorators';

@withRefreshTableOnFilterChange
class Clients extends Component {
    componentDidMount() {
        this.props.load(new URLSearchParams(history.location.search));
    }

    render() {
        let pages = -1;
        let showPaginationBottom = false;
        if (this.props.content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <ClientsTable
                data={this.props.content}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                user={this.props.user}
                location={this.props.location}
                history={history}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ...state.clients,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: searchParams => dispatch(actions.loadClients(searchParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
